module.exports = __webpack_public_path__ + "img/emporte-pieces-widddi.6e7ca80d.jpg";